module.exports = __webpack_public_path__ + "img/united-kingdom.fcc992ba.svg";